export default {
    data() {
        return {
            isOverFlow: {
                category: false,
                route: false
            }
        };
    },
    methods: {
        scrollCarousel(type, scrollAmount) {
            const carouselContainer = document.getElementById(type + 'Carousel');
            carouselContainer.scrollLeft += scrollAmount;
        },
        checkCarousel(type) {
            var container = document.getElementById(type + 'Carousel');
            if (!container) {
                this.isOverFlow[type] = false;
            } else {
                this.isOverFlow[type] = container.scrollWidth > container.clientWidth;
            }
        }
    }
};